import React, { useState } from 'react';
import { languages } from '../data/mock';

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  return (
    <div className="fixed bottom-6 left-6 z-40">
      <div className="relative">
        {/* Selected Language */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-white rounded-lg shadow-lg p-2 hover:shadow-xl transition-shadow duration-200"
        >
          <img 
            src={selectedLanguage.flag} 
            alt={selectedLanguage.name}
            className="w-10 h-7 object-cover rounded"
          />
        </button>

        {/* Language Options */}
        {isOpen && (
          <div className="absolute bottom-full mb-2 bg-white rounded-lg shadow-xl p-2 space-y-2">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  setSelectedLanguage(lang);
                  setIsOpen(false);
                }}
                className="block w-full hover:bg-gray-100 rounded p-1 transition-colors duration-150"
              >
                <img 
                  src={lang.flag} 
                  alt={lang.name}
                  className="w-10 h-7 object-cover rounded"
                />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
